import { AuthProvider, useAuth } from "./lib/AuthContext";
import * as Sentry from "@sentry/react";
import LoginPage from "./components/LoginPage";
import AppShell from "./components/AppShell";
import { COLORS } from "./lib/colors";

function AppContent() {
  const { session, candidate, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: COLORS.bg,
        fontFamily: "'DM Sans', sans-serif",
        color: COLORS.textMuted,
        fontSize: 14,
      }}>
        Loading...
      </div>
    );
  }

  if (!session || !candidate) {
    return <LoginPage />;
  }

  return <AppShell />;
}

function ErrorFallback({ resetError }) {
  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "center",
      minHeight: "100vh", backgroundColor: COLORS.bg,
      fontFamily: "'DM Sans', sans-serif", padding: 20,
    }}>
      <div style={{ textAlign: "center", maxWidth: 400 }}>
        <div style={{
          width: 48, height: 48, borderRadius: 12, backgroundColor: "#E5484D",
          display: "inline-flex", alignItems: "center", justifyContent: "center",
          color: "#fff", fontWeight: 700, fontSize: 22, marginBottom: 16,
        }}>!</div>
        <h2 style={{ fontSize: 18, fontWeight: 700, color: COLORS.text, marginBottom: 8 }}>
          Something went wrong
        </h2>
        <p style={{ fontSize: 14, color: COLORS.textMuted, marginBottom: 20 }}>
          An unexpected error occurred. Please try again.
        </p>
        <button onClick={resetError} style={{
          padding: "10px 24px", borderRadius: 8, border: "none",
          backgroundColor: COLORS.accent, color: "#fff", fontSize: 14,
          fontWeight: 600, fontFamily: "inherit", cursor: "pointer",
        }}>
          Try Again
        </button>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Sentry.ErrorBoundary fallback={({ resetError }) => <ErrorFallback resetError={resetError} />}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Sentry.ErrorBoundary>
  );
}
